import { Skeleton } from "@mui/material";

const SensorBoxSkeleton = () => {
  return (
    <Skeleton
      variant="rectangular"
      width="100%"
      height="68px"
      animation="wave"
    />
  );
};

export default SensorBoxSkeleton;
